import axios from 'axios';

let API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Normalizar URL base
if (API_BASE_URL.endsWith('/')) {
    API_BASE_URL = API_BASE_URL.slice(0, -1);
}

// Asegurar que termine en /api
if (!API_BASE_URL.endsWith('/api')) {
    API_BASE_URL = `${API_BASE_URL}/api`;
}

// Crear instancia de axios
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor para agregar token a todas las peticiones
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Validar si es FormData para eliminar el Content-Type y dejar que el navegador lo maneje
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Si el error es 401 y no es un retry
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshToken = localStorage.getItem('refresh_token');
                const response = await axios.post(`${API_BASE_URL}/auth/refresh/`, {
                    refresh: refreshToken,
                });

                const { access } = response.data;
                localStorage.setItem('access_token', access);

                // Reintentar la petición original
                originalRequest.headers.Authorization = `Bearer ${access}`;
                return api(originalRequest);
            } catch (refreshError) {
                // Si falla el refresh, limpiar tokens
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');

                // Evitar recarga si ya estamos en /login
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }

                return Promise.reject(refreshError);
            }
        }

        // Si es 401 pero es la ruta de login original, solo retorna el error
        // para que Login.jsx lo capture y muestre el mensaje sin recargar
        if (error.response?.status === 401 && originalRequest.url.includes('/auth/login')) {
            return Promise.reject(error);
        }

        // Intercepción Global para Muro de Pago (403 Subscription/Trial limits)
        if (error.response?.status === 403 && error.response.data && error.response.data.detail) {
            const detailStr = error.response.data.detail.toLowerCase();
            if (detailStr.includes('límite') || detailStr.includes('expirado') || detailStr.includes('suscripción')) {
                // Dynamically import Swal to avoid breaking the bundler immediately on load if not needed
                import('sweetalert2').then(({ default: Swal }) => {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Límite Alcanzado',
                        text: error.response.data.detail,
                        showCancelButton: true,
                        confirmButtonText: 'Ver Planes',
                        cancelButtonText: 'Entendido',
                        confirmButtonColor: '#4a00e0',
                        cancelButtonColor: '#6c757d',
                        background: '#ffffff',
                        backdrop: `rgba(0,0,123,0.4)`
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = '/pricing';
                        }
                    });
                });
                // No retornar reject para bloquear silenciosamente la caída de UI, o retornar reject modificado
                return Promise.reject(error);
            }
        }

        return Promise.reject(error);
    }
);

export const API_URL = API_BASE_URL;
export default api;

